import * as Yup from 'yup';

export const profileSchema = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  stateId: Yup.string().required('Required'),
  districtId: Yup.string().required('Required'),
  schoolName: Yup.string().required('Required'),
});
